import {ColumnDef} from '@/pages/feeds/Editor/Mapper/FieldDialog.tsx';
import {Button, MenuItem} from '@blueprintjs/core';
import {ItemRenderer, Select} from '@blueprintjs/select';
import {ReactElement, useCallback} from 'react';

export interface FeedKeySelectProps {
	items: ColumnDef[],
	value: string | null,
	onSelect: (feedKey: ColumnDef) => void,
}

export function FeedKeySelect({items, value, onSelect}: FeedKeySelectProps): ReactElement {
	const renderItem: ItemRenderer<ColumnDef> = useCallback(([key, sample], {handleClick, handleFocus, modifiers}) => {
		if (!modifiers.matchesPredicate)
			return null;

		let label = sample.substring(0, 40);

		if (sample.length > label.length)
			label += '...';

		return (
			<MenuItem
				key={key}
				text={key}
				label={label}
				active={modifiers.active}
				selected={key === value}
				roleStructure="listoption"
				onClick={handleClick}
				onFocus={handleFocus}
			/>
		);
	}, [value]);

	return (
		<Select
			items={items}
			itemRenderer={renderItem}
			onItemSelect={onSelect}
			itemPredicate={filterFileKey}
			fill={true}
			popoverProps={{matchTargetWidth: true, placement: 'bottom-start'}}
		>
			<Button
				alignText="start"
				text={value ?? 'Select a feed column...'}
				fill={true}
				endIcon="chevron-down"
			/>
		</Select>
	);
}

export function filterFileKey(query: string, [key]: ColumnDef): boolean {
	return key.toLowerCase().includes(query.toLowerCase());
}
